import React from 'react';
import './sectionTwo.scss';
// Reusing the same image from the previous section
import chatImage from '../../../resources/ASKEpm2.svg';

const SectionTwo = () => {
    // Inline SVG for the search icon to match the design exactly
    const SearchIcon = () => (
        <svg 
            width="22" 
            height="22" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="#FF5A14" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="search-icon"
        >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
    );

    return (
        <div id='SectionTwo' className='ask-questions-section'>
            <div className='section-header'>
                <h2 className='section-title'>
                    Ask your questions in <span className='highlight'>natural language</span>
                </h2>
            </div>

            <div className='graphic-container'>
                {/* Central Chat Window */}
                <div className='chat-window-wrapper'>
                    <img
                        className='chat-window-image'
                        src={chatImage}
                        alt='AskEPM Chat Interface'
                    />
                </div>

                {/* Floating Bubbles */}
                <div className='floating-bubble bubble-top-left'>
                    <SearchIcon />
                    <p>“Which markets, products or customers need intervention?”</p>
                </div>

                <div className='floating-bubble bubble-top-right'>
                    <SearchIcon />
                    <p>“Where are we likely to miss plan this month?”</p>
                </div>

                <div className='floating-bubble bubble-mid-left'>
                    <SearchIcon />
                    <p>“If supply or capacity is constrained, what should we prioritize?”</p>
                </div>

                <div className='floating-bubble bubble-bottom-right'>
                    <SearchIcon />
                    <p>“What is driving margin leakage in this business unit?”</p>
                </div>

                <div className='floating-bubble bubble-bottom-left'>
                    <SearchIcon />
                    <p>“Which actions can improve cash flow before month-end?”</p>
                </div>
            </div>
        </div>
    );
};

export default SectionTwo;